import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    floatingBtn: {
        position: 'absolute',
        left: '10px',
        top: '10px',
        zIndex: 1001,
        width: '42px',
        height: '42px',
        padding: '9px',
        borderRadius: '50%',
        backgroundColor: 'var(--account-accent, #0C6DDF)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
        '& .MuiSvgIcon-root': {
            color: 'var(--account-accent-contrast, #fff)',
        },
        '&:hover': {
            backgroundColor: 'var(--account-accent, #0C6DDF)',
            opacity: 1,
        },
        '.darkTheme &, .darkTheme &:hover': {
            backgroundColor: '#181c1e',
        },
    },
    mobileBtn: {
        position: 'absolute',
        right: '10px',
        top: '10px',
        zIndex: 555,
        width: '42px',
        height: '42px',
        padding: '9px',
        borderRadius: '50%',
        backgroundColor: 'var(--account-accent, #0C6DDF)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
        '& .MuiSvgIcon-root': {
            color: 'var(--account-accent-contrast, #fff)',
        },
        '&:hover': {
            backgroundColor: 'var(--account-accent, #0C6DDF)',
            opacity: 1,
        },
        '.darkTheme &, .darkTheme &:hover': {
            backgroundColor: '#181c1e',
        },
    },
    root:{
        width:{
            xs:'auto',
            lg:'40px'
        },
        '.lightTheme &': {
            backgroundColor:{
                xs:'transparent',
                lg:'#fff'
            },
        },
        padding:{
            xs:'0',
            lg:'10px'
        },
        display:'flex',
        justifyContent:'center',
        borderRadius:{
          xs:'10px',
          lg:'0'
        },
        height: {
            xs:'auto',
            lg:'100%'
        },
        position: {
            xs: 'absolute',
            lg: 'relative'
        },
        right: {
            xs: '10px',
            lg: 'auto'
        },
        top: {
            xs: '5px',
            lg: 'auto'
        },
        zIndex:{
            xs:555,
            lg:'initial'
        },
        boxShadow:'none'
    },
    icon:{
        transform:'rotate(180deg)',
        width:{
            xs:'20px',
            lg:'8px'
        },
        height:{
            xs:'20px',
            lg:'8px'
        },
        fill:{
            xs:'black',
            lg:'#BEBCB9'
        },
        '.darkTheme &':{
            fill:{
                xs:'white',
                lg:'#BEBCB9'
            },
        },
    }
}